import type { NodeId, NodeInstance, PortId } from '../../../types/graph';
import { DeferredCompositeCommand } from '../composite';
import { AddEdgeCommand } from '../elementary';
import { createAddNodeCommand } from '../elementary/add-node';
import { defaultIdFactory } from '../utils';

export interface AddChildCommandProps {
  created: {
    // Id of port of the created node to which we are connecting.
    // This is always only one option, but the caller needs to inform the value of the id.
    portId: PortId;
  };
  parent: {
    // Id of node to which we are connecting.
    nodeId: NodeId;
    // Id of port of the node to which we are connecting.
    portId: PortId;
  };
  // Details of node to be created.
  node: Omit<NodeInstance, 'id'>;
}

export const createAddChildCommand = ({
  created,
  parent,
  node,
}: AddChildCommandProps) => {
  const newNodeId = defaultIdFactory.nodeId();
  const newEdgeId = defaultIdFactory.edgeId();

  return new DeferredCompositeCommand((graph) => {
    const newNode: NodeInstance = {
      ...node,
      id: newNodeId,
    };

    const newEdge = {
      id: newEdgeId,
      from: {
        nodeId: newNodeId,
        portId: created.portId,
      },
      to: {
        nodeId: parent.nodeId,
        portId: parent.portId,
      },
    };

    return [createAddNodeCommand(newNode), new AddEdgeCommand(newEdge)];
  }, 'Add child to node');
};
